"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./NavTabs.css");
function Item(_a) {
    var label = _a.label, Icon = _a.icon, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.badge, badge = _c === void 0 ? false : _c, onClick = _a.onClick;
    var mainClass = (0, classnames_1.default)("nimbus--nav-tabs-item", {
        "nimbus--nav-tabs-item--active": active,
        "nimbus--nav-tabs-item--badge": badge,
    });
    return (React.createElement("button", { title: label, type: "button", onClick: onClick, className: mainClass },
        React.createElement(Icon, { size: "medium" })));
}
exports.default = Item;
//# sourceMappingURL=NavTabs.Item.js.map